/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, get, sortBy, sum } from "lodash";
import { isEmpty, trim } from "lodash-es";
import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2"
import { getStatisticsCardPurchases, getStatisticsCategoriesCardPurchases } from "../../../apis/finances/statistics";
import { CardHeader, CardUnit, Col, Row } from "../../../components/ContentLayout";
// import DataComponent from "../../../components/DataComponent";
// import Line from "../../../components/Line";
import RankList from "../../../components/List/RankList";
import Loading from "../../../components/Loading";
import NoData from "../../../components/NoData/NoData";
import { convertHexToRGBA, getColor } from "../../../utils/color";
import { dateToViewFormat, getMonthRange } from "../../../utils/date";
import { comma } from "../../../utils/number";
// import { getFinancesStatistics } from "../../../utils/financesStatistics";
// import { comma } from "../../../utils/number";
import { classnames } from "../../../utils/text";

const getChartColors = (color) => {
  return [
    {
      backgorund: color,
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 80),
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 60),
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 40),
      labelColor: color,
    },
    {
      backgorund: convertHexToRGBA(color, 20),
      labelColor: color,
    },
    {
      backgorund: getColor("color-gray-0"),
      labelColor: getColor("color-gray-5"),
    },
  ]
}

const CardUsedPieChartItem = ({
  activeTab,
  params = {},
  color,
}) => {
  const [colors] = useState(getChartColors(color));
  const [list, setList] = useState(null);
  const [data, setData] = useState(null);
  const [options, setOptions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isEmpty(params)) {
      submit(params)
    }
  }, [params, activeTab])

  const submit = (date) => {
    //console.log(date)
    setIsLoading(true)
    if (activeTab === 0) {
      getStatisticsCardPurchases({
        groupBy: 'month',
        range: {
          date
        }
      }).then((res) => {
        const datas = []
        const purchaseList = get(res, "data.data.purchaseList", [])
        forEach(purchaseList, (purchase) => {
          let name = ""
          if(!isEmpty(purchase.card.nickName) && trim(String(purchase.card.nickName)) !== "") {
            name = `${purchase.card.cardName} - [${trim(String(purchase.card.nickName))}]`
          } else {
            name = `${purchase.card.cardName}`
          }

          datas.push({
            label: name,
            data: purchase.useAmt
          })
        })

        const _data = sortBy(datas, ['data']).reverse().slice(0, 8)
        setList(_data)
        setData({
          labels: _data.map(d => d.label),
          datasets: [{
            data: _data.map(d => d.data),
            backgroundColor: colors.map(c => c.backgorund),
            borderWidth: 0
          }]
        })
        setOptions({
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 10,
              top: 20,
              bottom: 0
            }
          },
          plugins: {
            datalabels: {
              color: colors.map(c => c.labelColor),
              formatter: (value) => {
                return comma(value / sum(_data.map(d => d.data)) * 100, 2) + '%'
              },
            },
          },
          tooltips: {
            callbacks: {
              label: function ({ datasetIndex, index, label: totalLabel }, data) {
                const target = data.datasets[datasetIndex]
                return `${data.labels[index]} : ${comma(target.data[index])}원`
              }
            }
          }
        })
      })
        .catch(() => { })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      getStatisticsCategoriesCardPurchases({
        groupBy: 'month',
        range: {
          date
        }
      }).then((res) => {
        const datas = []
        const purchaseList = get(res, "data.data.purchaseList", [])
        forEach(purchaseList, (purchase) => {
          datas.push({
            label: `${purchase.accountingTitleName}(${purchase.accountingTitleCode})`,
            data: purchase.useAmt
          })
        })

        const _data = sortBy(datas, ['data']).reverse().slice(0, 8)
        setList(_data)
        setData({
          labels: _data.map(d => d.label),
          datasets: [{
            data: _data.map(d => d.data),
            backgroundColor: colors.map(c => c.backgorund),
            borderWidth: 0
          }]
        })
        setOptions({
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 10,
              top: 20,
              bottom: 0
            }
          },
          plugins: {
            datalabels: {
              color: colors.map(c => c.labelColor),
              formatter: (value) => {
                return comma(value / sum(_data.map(d => d.data)) * 100, 2) + '%'
              },
            },
          },
          tooltips: {
            callbacks: {
              label: function ({ datasetIndex, index, label: totalLabel }, data) {
                const target = data.datasets[datasetIndex]
                return `${data.labels[index]} : ${comma(target.data[index])}원`
              }
            }
          }
        })
      })
        .catch(() => { })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  return <Row className="card-used-pie">
    {isLoading ?
      <Loading color={color} /> :
      isEmpty(list) ? <NoData /> :
        <>
          <Col lg={5}>
            {data &&
              <Pie
                data={data}
                options={options}
                height={300}
              />
            }
          </Col>
          <Col lg={7}>
            <RankList
              color={color}
              list={list}
            ></RankList>
          </Col>
        </>
    }
  </Row>
}

const CardUsedPieChart = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [monthDate, setMonthDate] = useState({})
  const [monthMargin, setMonthMargin] = useState(0)
  const [params, setParams] = useState({})

  useEffect(() => {
    setMonthDate(getMonthRange(monthMargin, true))
  }, [monthMargin])

  const getPreMonth = () => {
    setMonthMargin(monthMargin + 1)
  }
  const getNextMonth = () => {
    setMonthMargin(monthMargin - 1)
  }

  const tabList = [
    { label: "카드별 조회", action: setActiveTab },
    { label: "카테고리별 조회", action: setActiveTab },
  ];

  useEffect(() => {
    if (!isEmpty(monthDate)) {
      setParams(monthDate)
    }
  }, [monthDate])

  return <div className="card-used-pie-chart">
    <>
      <CardHeader className="border-bottom-none">
        신용카드 사용
        <CardUnit>
          <div className="weekly-date-wrap">
            <button className="weekly-button pre" onClick={getPreMonth}>
              <span className="pre" />
            </button>
            <div className="weekly-date">{dateToViewFormat(monthDate.from, 'YYYY.MM')}</div>
            <button className="weekly-button next" onClick={getNextMonth}>
              <span className="next" />
            </button>
          </div>
        </CardUnit>
        <div className="tab-list-wrap">
          <ul className="tab-list">
            {tabList.map((tab, idx) => (
              <li
                key={idx}
                className={classnames("tab-item", {
                  active: activeTab === idx,
                })}
              >
                <a onClick={() => tab.action(idx)}>{tab.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </CardHeader>
      <CardUsedPieChartItem
        color={getColor("color-orange-100")}
        params={params}
        activeTab={activeTab}
      />
    </>
  </div >
}

export default CardUsedPieChart